"use strict";

import International from "scripts/components/International";
document.addEventListener("DOMContentLoaded", function () {
  International();
});
window.addEventListener("load", function () {});
